import { z } from 'zod';
import { ComponentTypeSchema } from './site-report.js';
import { SiteSummarySchema } from './sites.js';
/** SiteComponent tak, ako ho vidí dashboard. `removedAt` ≠ null = odinštalovaný, ostáva v histórii. */
export const SiteComponentViewSchema = z.object({
    id: z.string(),
    type: ComponentTypeSchema,
    slug: z.string(),
    name: z.string(),
    version: z.string(),
    /** false = verzia sa nedá zakľúčovať → komponent sa nikdy nenamatchuje (panel pokrytia) */
    keyable: z.boolean(),
    active: z.boolean(),
    updateAvailable: z.string().nullable(),
    file: z.string().nullable(),
    firstSeenAt: z.string(),
    lastSeenAt: z.string(),
    removedAt: z.string().nullable(),
});
export const RunStatusSchema = z.enum(['RUNNING', 'SUCCEEDED', 'FAILED']);
export const RunTriggerSchema = z.enum(['CRON', 'MANUAL', 'WEBHOOK']);
/** Jeden zber Inventory + matching. Nemíňa kvótu — nie je to FeedSyncRun. */
export const ScanRunViewSchema = z.object({
    id: z.string(),
    siteId: z.string(),
    trigger: RunTriggerSchema,
    status: RunStatusSchema,
    startedAt: z.string(),
    finishedAt: z.string().nullable(),
    error: z.string().nullable(),
    componentsCount: z.number().int().nullable(),
    findingsOpened: z.number().int().nullable(),
    findingsResolved: z.number().int().nullable(),
});
export const SiteDetailSchema = SiteSummarySchema.extend({
    wpVersion: z.string().nullable(),
    phpVersion: z.string().nullable(),
    counts: z.object({
        plugins: z.number().int(),
        themes: z.number().int(),
        withUpdate: z.number().int(),
        removed: z.number().int(),
    }),
    lastScan: ScanRunViewSchema.nullable(),
});
